import React from "react";
import KitMeasurements from "../admin/coaching-camp/KitMeasurements";

const CoachKits = () => {
  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-emerald-800 to-cyan-900 rounded-3xl p-6 text-white shadow-lg">
        <h1 className="text-2xl font-black tracking-tight">
          Team Athletes Kit Measurements & Caste Details
        </h1>
        <p className="text-cyan-100 text-xs mt-1">
          Record, update, and manage kit measurements (height, weight, dress size, shoe size) and caste/category details for your allotted squad athletes.
        </p>
      </div>

      <KitMeasurements isCoach={true} />
    </div>
  );
};

export default CoachKits;
